module.exports = __webpack_public_path__ + "img/yellow.b22c6e58.png";